import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FieldService } from '../field/field/field.service';
import { EngineDataQueryService } from '@tj/tj-dmp-lib-api';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'dmp-reassign-purchase',
    templateUrl: './reassign-purchase.component.html',
    styleUrls: ['./reassign-purchase.component.scss'],
    standalone: false
})
export class ReassignPurchaseComponent implements OnInit {

  @Input() commandId: number
  @Input() personalId: number;
  @Input() email: string;

  form: FormGroup

  constructor(
    private fb: FormBuilder,
    public fieldService: FieldService,
    private queryService: EngineDataQueryService,
    private messageService: MessageService,
    private translate: TranslateService
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.email]],
      isReassignEnabled: [false]
    })
  }

  ngOnInit(): void {
  }

  onEmailChange() {
    const email: string = this.form.get('email')?.value.trim();
    if(email == null || email == ""){
      this.fieldService.reassignCustomer(null);
      return;
    }
    this.queryService.getPersonalIdByEmail(email,this.fieldService.datastore).subscribe({
      next: (res) => {
        if (res) {
          this.fieldService.reassignCustomer(res);
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Non trouvé',
            detail: `Aucun contact trouvé avec l'email ${email}.`
          });
        }
      },
    });
  }

}
